import type { NodeName } from '@farmersdog/constants';
import { NodeNames } from '@farmersdog/constants';

export const exclusionList: Set<NodeName> = new Set([
  NodeNames.BirthdayAmount,
  NodeNames.BirthdayUnit,
]);
